<template>
    <div class="notifications">
        <div class="ui icon button" ref="notification_button">
            <i class="loading circle notch large icon" v-if="has_processing"></i>
            <i class="paper plane outline large icon" v-else-if="notifications.length == 0"></i>
            <i class="paper plane large icon" v-else></i>

            <div class="floating ui red circular label" v-if="unread_notificatons.length > 0" style="top: -0.5em;">
                {{ unread_notificatons.length }}
            </div>
        </div>
        <div class="ui flowing scrolling popup hidden">
            <div class="ui feed" v-if="notifications.length > 0">
                <Notification v-for="notification in notifications" :key="notification.identity" :notification="notification"></Notification>
            </div>
            <div class="ui feed" v-else>
                <div class="event">
                    <div class="label">
                        <i class="hand peace outline icon"></i>
                    </div>
                    <div class="content">
                        <div class="summary">
                            <!-- 沒有新通知 -->
                            {{ $t("ui.toolbox.notifications.no_news.title") }}
                        </div>
                        <div class="extra text">
                            <!-- 目前沒有新通知，所有的新通知會顯示於此。 -->
                            {{ $t("ui.toolbox.notifications.no_news.content") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notification from "./item.vue"
export default {
    name: "ToolNotificationMain",
    props: {
        channel_identity: String
    },
    data() {
        return {
            unread_notificatons_count: 0,
        }
    },
    computed: {
        notifications() {
            return this.$store.state.provider.notifications
        },
        has_processing() {
            return _.findLast(this.notifications, (notification) => {return notification.status == 'processing'})
        },
        unread_notificatons: {
            cache: false,
            get () {
                return _.filter(this.notifications, (notification) => {return !notification.is_read})
            }
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        $(this.$refs.notification_button).popup({
            on: 'click',
            hoverable: true,
            position: 'bottom center',
            lastResort: 'bottom center',
            onShow: () => {
                $('.ui.popup').css('max-height', $(window).height())
                this.notifications.forEach((notification, index) => {
                    this.notifications[index].is_read = true
                })
            },
            delay: {
                show: 300,
                hide: 500
            }
        })
        this.$cable.subscriptions.create(
            {
                channel: 'NotificationsChannel',
                channel_identity: this.channel_identity,
            },
            {
                connected: () => {
                    console.log("NotificaiontsChannel connected")
                },
                received: (data) => {
                    data.is_read = false
                    var index = _.findIndex(this.notifications, notification => notification.identity == data.identity)
                    if (index >= 0) {
                        this.$store.commit('provider/update_notification', data)
                    } else {
                        this.$store.commit('provider/add_notification', data)
                    }
                }
            }
        )
    },
    beforeDestroy() {
    },
    methods: {
        toggle_all_to_read() {
            _.forEach(this.$children, (child) => {
                child.toggle_is_read()
            })
        }
    },
    components: {
        Notification,
    }
}
</script>

<style scoped>
@media only screen and (max-width: 767px) {
    .ui.flowing.popup {
        width: 80vw;
    }
    .ui.flowing.popup .ui.feed {
        max-height: 80vh !important;
    }
}
.ui.flowing.popup {
    min-width: 20vw;
}
.ui.flowing.popup .ui.feed {
    max-height: 50vh !important;
    overflow-y: auto;
}
</style>
